import {_} from "./trans";
let orgLang = document.querySelector('html').getAttribute('org-lang')

export default function (auth = false, admin = false) {
    // _ is translate
    let authItem = []
    if(auth) {
        let background = []
        if(admin)
            background.push({title: _('backendMgr'), url: 'b.index'})
        authItem = [{
            title: _('memCenter'), children: [
                ...background,
                // {title: _('cart'), url: 'f.shop.cart.index'},
                // {title: _('orderList'), url: 'f.shop.order.ls'},
                {title: _('memCenter'), url: 'f.user.info.index'},
                {title: _('logout'), url: 'f.user.entry.logout'},
            ], url: 'f.user.info.index',
        }]
    } else {
        authItem = [
            {title: _('login'), url: 'f.user.entry.page.login'},
            // {title: _('register'), url: 'f.user.entry.page.register'},
        ]
    }
    let result = [
        {title: _('home'), url: 'home'},
        (orgLang === 'zh-CN' ? {title: _('ourHonor'), url: 'f.ourhonor.index'} : null),
        {title: _('prodList'), url: 'f.products.index'},
        {
            title: _('introd'),
            children: document.querySelector('html').getAttribute('lang') === 'en'
                ? [
                    {title: _('pepSyn'), url: 'f.introd.instru.newcsbio'},
                ]
                : [
                    {title: _('newProdList'), url: 'f.introd.newprod.index'},
                    {title: _('pepSyn'), url: 'f.introd.instru.newcsbio'},
                    {title: _('peptide'), url: 'f.introd.peptide.gmppeptideproduction'},
                    {title: _('pepReag'), url: 'f.introd.pepreagent.aminoacidsandresins'},
                    {title: _('antiBodyProdTitle'), url: 'f.antibodyprod.index'},
                    {title: _('qulityCtrl'), url: 'f.introd.qualityassurance.qualityassurance'},
                    {title: _('preHplcAndCol'), url: 'f.introd.prehplcandcolumn.prephplcsys'},
                    {title: _('agent'), url: 'f.introd.agent.index'},
                ],
            url: 'f.introd.instru.newcsbio',
        },
        {title: (document.querySelector('html').getAttribute('lang') === 'en'
            ? 'About Us'
            : '關於我們'), url: 'f.aboutus.index'},
        {title: _('contactUs'), url: 'f.contactus.index'},
        (orgLang === 'zh-CN' ? {title: _('career'), url: 'f.career.index'}: null),
        ...authItem,
        // {title: _('cart'), url: 'f.shop.cart.index'},
    ]
    result = result.filter((v) => {
        return !!v
    })
    return result
}
